const FULL_WIDTH_MODULES_MOBILE_ONLY = ['promo_banner'];

const isFullWidthMobileOnly = (moduleName) => FULL_WIDTH_MODULES_MOBILE_ONLY.includes(moduleName);

export default isFullWidthMobileOnly;
